import { createStore } from 'zustand';

import type { AgreementType } from '@MP/shared/api/hooks/patient';

/** ViewModel이 소비하는 데이터 접근 계층. 컴포넌트가 React Query 훅으로 구현체를 조립해 생성 시 1회 주입한다. */
export interface PatientAgreementRepository {
  fetchUrl: (patientId: string, types: AgreementType[]) => Promise<string>;
  send: (params: { patientId: string; types: AgreementType[] }) => Promise<unknown>;
}

export interface PatientAgreementSendState {
  qrUrl: string;
  isFetchingUrl: boolean;
  isSending: boolean;
  fetchAgreementUrl: (params: { patientId: string; types: AgreementType[] }) => Promise<void>;
  /** 발송 완료 시 true를 반환한다. */
  send: (params: { patientId: string; types: AgreementType[] }) => Promise<boolean>;
  reset: () => void;
}

const createPatientAgreementSendStore = (repo: PatientAgreementRepository) =>
  createStore<PatientAgreementSendState>((set) => ({
    qrUrl: '',
    isFetchingUrl: false,
    isSending: false,
    fetchAgreementUrl: async ({ patientId, types }) => {
      set({ isFetchingUrl: true });
      try {
        const url = await repo.fetchUrl(patientId, types);
        if (url) {
          set({ qrUrl: url });
        }
      } finally {
        set({ isFetchingUrl: false });
      }
    },
    send: async ({ patientId, types }) => {
      set({ isSending: true });
      try {
        await repo.send({ patientId, types });
        return true;
      } finally {
        set({ isSending: false });
      }
    },
    reset: () => set({ qrUrl: '', isFetchingUrl: false, isSending: false }),
  }));

export const PatientAgreementSendViewModel = {
  createStore: createPatientAgreementSendStore,
};
